export enum FeatureFlagEnum {
  OVERLAY_NAVIGATION_EXPANSION = "overlay-navigation-expansion",
  CROSS_ORGANISATION_SHARING = "cross-organisation-sharing",
  CROSS_ORGANISATION_SHARING_PROCESS = "cross-organisation-sharing-process",
  CROSS_ORGANISATION_SHARING_LOCATION = "cross-organisation-sharing-location",
  LANGUAGES = "languages",
  DELIVERY_REPORT_PRINT = "delivery-report-print",
  DARK_MODE = "dark-mode",
  SUPPLY_CHAIN_SHOW_ORG_DOCS_AND_CERTS = "supply-chain-show-org-docs-and-certs",
  NEW_DOCUMENT_UPLOAD_UI = "new-document-upload-ui",
  PURCHASE_ORDERS = "purchase-orders",
  QUERIED_MATERIALS = "queried-materials",
  GPS_MANUAL_ENTRY_FORMATS = "gps-manual-entry-formats",
  OAUTH_MICROSOFT = "oauth-microsoft",
}
